import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { Child } from '@/types/child';

export const getChildrenByLineID = async (
  lineID: string,
  accessToken: string
): Promise<ApiResult<Child[]>> => {
  const { status, result } = await callApiWithoutToken<Child[]>(
    `line/${lineID}/children`,
    'GET',
    accessToken
  );
  return { status, result };
};
